// extracted by mini-css-extract-plugin
module.exports = {"button":"modal-button_button__1dz-4","button_modal":"modal-button_button_modal__Fdomf","button_modal_closed":"modal-button_button_modal_closed__RGoPC"};